import { API_CONFIG } from "common/config";
import { COMMON_JS } from "common/scripts";

export const CRM_APIs = {
  manageCrmLeadProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/D66W379BYS9SAL52",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },
  getLeadProfiles: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ac/v1/149Z7769V62163UT",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },
  getCrmDocuments: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/R4W8OQMOLYH02ACT",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  manageCrmLeadDocument: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/6DX11JJXE7RM0NSB",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },
  getCrmLeadDocuments: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/923G194QZUQQRC9N",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCrmApprovals: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/48GR8BYQUY4SOU02",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCrmLeadApprovals: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/UP9O0S3J9ZSEYHVI",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
  manageCrmLeadApproval: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/5SLCS9BCN0BGUG2R",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },
};
